const TermsAndCondition = () => {
  return (
    <div className="text-gray-700 text-base max-h-[28rem] overflow-y-auto thin-scroll">
      <div className="p-5 text-left break-spaced">
        <div className="text-left">
          <p className="mb-3">GoLeads.com(tm) Subscription Service Agreement</p>

          <p className="mb-3">
            IMPORTANT: BY ACCESSING ANY PART OF THE GOLEADS ONLINE SERVICE
            ("GOLEADS ONLINE", OR THE "SERVICE") YOU ARE REPRESENTING THAT YOU
            ARE EITHER OVER THE AGE OF 18 OR HAVE OBTAINED YOUR PARENT'S CONSENT
            TO REGISTER FOR THE SERVICE, AND YOU ARE AGREEING TO ALL THE TERMS
            AND CONDITIONS OF THIS SUBSCRIPTION SERVICE AGREEMENT (THE "SERVICE
            AGREEMENT" OR "THIS AGREEMENT"), AND CONSENT TO BE BOUND BY AND
            BECOME A PARTY TO THIS SERVICE AGREEMENT. IF YOU DO NOT AGREE TO ALL
            THE TERMS AND CONDITIONS OF THIS SERVICE AGREEMENT, OR CANNOT COMPLY
            WITH THESE TERMS AND CONDITIONS, YOU WILL STOP ALL USE OF THE
            SERVICE AND WILL HAVE NO AUTHORITY TO USE THE SERVICE.
          </p>

          <p className="mb-3">
            THE LISTS SUPPLIED BY GOLEADS.COM TO CLIENT SHALL BE HELD IN STRICT
            CONFIDENCE BY CLIENT AND SHALL NOT BE DISCLOSED TO ANY THIRD PARTY
            OR USED FOR ANY PURPOSE THAT IS NOT AUTHORIZED BY THESE STANDARD
            CONDITIONS. CLIENT MAY USE GOLEADS.COM DATA SOLELY FOR CLIENT'S
            MARKETING PROGRAMS AND FOR NO OTHER PURPOSE. NO NAMES OR OTHER DATA
            ELEMENTS DERIVED FROM GOLEADS.COM DATA MAY BE SOLD, RENTED,
            LICENSED, SUBLICENSED OR OTHERWISE PROVIDED TO ANY THIRD PARTY. NO
            NAMES OR OTHER DATA ELEMENTS DERIVED FROM GOLEADS.COM DATA MAY BE
            USED TO ENHANCE A FILE OR LIST OWNED BY ANY THIRD PARTY, TO DEVELOP
            ANY LIST, ENHANCEMENT OR PRODUCT WHICH IS COMPETITIVE WITH
            GOLEADS.COM'S PRODUCTS OR SERVICES, OR TO PREPARE, PUBLISH, CLEAN OR
            MAINTAIN ANY DIRECTORY OF ANY NATURE.
          </p>

          <p className="mb-3">
            NO MARKETING MATERIAL, SOLICITATION, ADVERTISEMENT OR OTHER
            COMMUNICATION SENT OR MADE TO PERSONS ON A LIST CREATED USING
            GOLEADS.COM DATA SHALL MAKE REFERENCE TO ANY SELECTION CRITERIA OR
            PRESUMED KNOWLEDGE REGARDING THE INTENDED RECIPIENT OF SUCH
            SOLICITATION, OR THE SOURCE OF THE RECIPIENT'S NAME AND ADDRESS,
            EXCEPT TO THE EXTENT SUCH INFORMATION IS DERIVED FROM CLIENT DATA.
            CLIENT SHALL COMPLY WITH ALL LAWS, REGULATIONS AND RELEVANT DIRECT
            MARKETING ASSOCIATION (DMA) GUIDELINES AND PRACTICES IN CONNECTION
            WITH ANY USE MADE OF GOLEADS.COM DATA. CLIENT SHALL NOT USE
            GOLEADS.COM DATA FOR PURPOSES OF MAILING PORNOGRAPHIC OR SEXUALLY
            EXPLICIT MATERIAL, CHAIN LETTERS, PYRAMID FUNDRAISING SOLICITATIONS
            OR OTHER SIMILAR PURPOSES. UPON GOLEADS.COM'S REQUEST, CLIENT SHALL
            FURNISH GOLEADS.COM SAMPLE MAIL PIECES, TELEMARKETING SCRIPTS, AD
            COPY OR OTHER COMMUNICATIONS THAT CLIENT INTENDS TO USE.
          </p>

          <p className="mb-3">
            CLIENT WILL ISSUE APPROPRIATE INSTRUCTION TO EACH EMPLOYEE OR THIRD
            PARTY GIVEN ACCESS TO GOLEADS.COM DATA OF THE RESTRICTIONS IN THIS
            AGREEMENT, AND SHALL PROVIDE PHYSICAL SECURITY OF GOLEADS.COM DATA
            TO AT LEAST THE DEGREE THAT CLIENT PROTECTS ITS OWN MOST SENSITIVE
            DATA. CLIENT SHALL NOT GRANT ACCESS TO THE GOLEADS.COM DATA TO
            INDIVIDUALS INCARCERATED IN PRISONS OR CORRECTIONAL INSTITUTIONS.
          </p>

          <p className="mb-3">
            CLIENT WILL MAINTAIN CURRENT, ACCURATE AND COMPLETE BOOKS AND
            RECORDS RELATING TO ITS USE OF GOLEADS.COM DATA FOR A PERIOD OF AT
            LEAST TWELVE (12) MONTHS AFTER EACH MARKETING COMMUNICATION. IN
            ADDITION TO FINANCIAL DETAIL, CLIENT SHALL MAINTAIN A FILE OF THE
            LATEST TWELVE (12) MONTHS OF COMMUNICATIONS, TO INCLUDE; SAMPLE MAIL
            PIECES, TELEMARKETING SCRIPTS, AD COPY OR OTHER COMMUNICATIONS WHICH
            CLIENT INTENDS TO USE. GOLEADS.COM, OR ANY REPRESENTATIVE IT
            DESIGNATES, WILL HAVE THE RIGHT TO EXAMINE AND COPY OR MAKE EXTRACTS
            FROM ALL SUCH BOOKS AND RECORDS AND ANY SOURCE DOCUMENTS USED IN
            PREPARATION THEREOF, AT ANY TIME DURING NORMAL BUSINESS HOURS,
            PROVIDED GOLEADS.COM GIVES CLIENT WRITTEN NOTICE AT LEAST THREE (3)
            BUSINESS DAYS PRIOR TO ANY SUCH EXAMINATION.
          </p>

          <p className="mb-3">
            IF YOU ARE DEEMED TO HAVE ORDERED THE SERVICE, THE ACCEPTANCE OF
            GOLEADS.COM ("GOLEADS") IS EXPRESSLY CONDITIONED UPON ASSENT TO ALL
            THE TERMS AND CONDITIONS OF THIS SERVICE AGREEMENT, TO THE EXCLUSION
            OF ALL OTHER TERMS; IF THESE TERMS ARE CONSIDERED AN OFFER BY
            GOLEADS, ACCEPTANCE IS EXPRESSLY LIMITED TO THESE TERMS.
          </p>

          <p className="mb-3">
            <strong>1. The Service</strong>
          </p>

          <p className="mb-3">
            The Service consists of a browser interface, marketing database,
            data encryption, data transmission, data access (as available) and,
            if applicable, synchronization software and data storage. You are
            responsible for obtaining and maintaining all computer hardware,
            software and communications equipment needed to access the Service,
            and for paying all third-party access charges (e.g., kiosk, ISP,
            telecommunications) incurred while using the Service.
          </p>

          <p className="mb-3">
            GoLeads makes no guarantees as to the continuous availability of the
            Service or of any specific feature(s) of the Service. GoLeads
            reserves the right to change the Service or the terms and conditions
            of this Agreement at any time without notice. All service agreements
            are for a consecutive twelve (12) month period, cancellable by you,
            the individual/customer, at any time thereafter so long as no data
            is downloaded after the 12th month. If you, the individual/customer
            downloads data after the beginning of the 13th month of
            subscription, customer is then in agreement to pay for a minimum of
            another 12 months.
          </p>

          <p className="mb-3">
            <strong>2. Use of Proprietary Software</strong>
          </p>

          <p className="mb-3">
            Subject to the terms and conditions of this Service Agreement,
            GoLeads grants you an individual, personal, non-sublicensable,
            non-exclusive and non-transferable license (the "License") to use
            its proprietary software, in object code form only, and proprietary
            database only in accordance with the applicable end user
            documentation, if any, and only in conjunction with this Service
            Agreement. You will not, directly or indirectly, reverse engineer,
            decompile, disassemble or otherwise attempt to discover the source
            code or underlying ideas or algorithms of the software or database;
            modify, translate, or create derivative works based on the software
            or database; or rent, lease, distribute, sell, resell, assign, or
            otherwise transfer rights to the software or database; use the
            software or database for timesharing or service bureau purposes or
            otherwise for the benefit of a third party; or remove any
            proprietary notices or labels on the software or database. As
            between the parties, you acknowledge that GoLeads retains exclusive
            ownership throughout the world of all software and database, any
            portions or copies thereof, and all rights therein. Upon termination
            of this Service Agreement for any reason, this License will
            terminate, and you will cease to use access the software or
            database. THE SOFTWARE AND DATABASE ARE PROVIDED "AS IS" AND "AS
            AVAILABLE" AND SUBJECT TO THE WARRANTY DISCLAIMERS AND LIMITATIONS
            OF LIABILITY FOUND IN THIS SERVICE AGREEMENT.
          </p>

          <p className="mb-3">
            <strong>3. Restrictions and Policies</strong>
          </p>

          <p className="mb-3">
            You will not use the service in any way for spamming, chain letters,
            junk mail, illegal fax broadcasting or distribution lists to any
            person who has not given specific permission to be included in such.
            You agree not to transmit through the Service any unlawful,
            harassing, libelous, abusive, threatening, harmful, vulgar, obscene
            or otherwise objectionable material of any kind. You will only use
            the Service for lawful purposes, in compliance with all applicable
            laws including, without limitations, copyright, trademark, obscenity
            and defamation laws. Unlawful activities may include (without limit)
            storing, distributing or transmitting any unlawful material,
            attempting to compromise the security of any networked account or
            site, or making direct threats of physical harm. You hereby agree to
            defend and indemnify GoLeads against any claim or action that arises
            from your use of the Service in an unlawful manner or in any manner
            inconsistent with the restrictions and policies stated herein.
          </p>

          <p className="mb-3">
            It is GoLeads policy to respect the privacy of its customers.
            Nevertheless, GoLeads reserves the right to access and disclose any
            information, data, graphics, video, sound, files and other content
            created by, provided by, or accessed by you ("Content") in order to
            comply with applicable laws and lawful government requests, to
            operate its business properly, or to protect its customers or
            itself. This may also include disclosing licensees' names and other
            registration and identification information. GoLeads reserves the
            right in its sole discretion, but will not be obligated, to remove
            any Content from its system. GoLeads will fully cooperate with law
            enforcement authorities in investigating suspected lawbreakers, and
            reserves the right to report to such authorities any suspect
            activity of which it becomes aware.
          </p>

          <p className="mb-3">
            M&amp;C Information Systems, Inc and GoLeads provides business
            information to help small business owners and salespeople grow their
            business. Information on this website includes company name,
            address, city, state, zip code, phone number, fax number, SIC Code,
            SIC Description, employee size and key decision-maker. It is the
            customer’s responsibility to abide by all local, state and federal
            laws in regards to direct mail, telemarketing and faxing. Customer
            agrees not to hold M&amp;C Information Systems, Inc liable for any
            wrongdoing regarding usage of the data.
          </p>

          <p className="mb-3">
            <strong>4. Support</strong>
          </p>

          <p className="mb-3">
            Under no circumstances will GoLeads have any obligation to provide
            you with hard-copy documentation, upgrades, enhancements,
            modifications, or other support, including, without limitation,
            phone support unless specifically contracted for.
          </p>

          <p className="mb-3">
            <strong>
              5. Payment of Fees (not applicable to "trial" period or
              promotions)
            </strong>
          </p>

          <p className="mb-3">
            You agree to provide GoLeads with accurate and complete billing
            information, including your legal name, address and telephone
            number, and to update this information within 30 days of any change
            to it for twelve (12) consecutive months of service. Payment by
            fraudulent means will result in immediate and permanent termination
            of the account, and possible criminal penalties. You will pay
            GoLeads, by authorized credit card, the then applicable fees (the
            "Fees"). Applicable Fees for use of the basic Service and Fees
            applicable to additional services are available at www.goleads.com.
            GoLeads reserves the right to change the Fees or applicable charges
            and to institute new charges at any time, upon thirty (30) days
            prior notice to you (which may be sent by email). The Fees will
            automatically be charged monthly in advance.
          </p>

          <p className="mb-3">
            Your GoLeads account will be considered delinquent if your credit
            card company refuses for any reason to pay the amount billed to it
            and that amount remains unpaid at the beginning of the next
            accounting cycle. The additional services may be suspended, archived
            or purged from system if account is delinquent for more than one
            billing cycle. GoLeads may impose a charge to restore archived data
            from delinquent accounts.
          </p>

          <p className="mb-3">
            If you believe GoLeads has billed you incorrectly, you must contact
            GoLeads no later than 60 days after the closing date on the first
            billing statement in which the error or problem appeared, in order
            to receive an adjustment or credit. Inquiries should be directed to
            GoLeads' Customer Support department.
          </p>

          <p className="mb-3">
            GoLeads may choose to bill through an invoice, in which case, full
            payment for invoices issued in any given month must be received by
            GoLeads fifteen (15) days after the mailing date of the invoice, or
            the Service may be terminated. Unpaid invoices are subject to
            interest of 1.5% per month on any outstanding balance, or the
            maximum permitted by law, plus all expenses of collection.
          </p>

          <p className="mb-3">
            <strong>6. Passwords and Security</strong>
          </p>

          <p className="mb-3">
            You will choose or be given a password to use in connection with the
            Service. You are entirely responsible for maintaining the
            confidentiality of your password and account. No one but you, the
            customer, is allowed to use that login and password. Furthermore,
            you are entirely responsible for any and all activities that occur
            under your account, and you shall ensure that you exit from your
            account at the end of each session.. You shall notify GoLeads
            immediately of any unauthorized use of your account or any other
            breach of security. GoLeads cannot and will not be liable for any
            loss or damage arising from your failure to comply with these
            requirements.
          </p>

          <p className="mb-3">
            <strong>7. Termination</strong>
          </p>

          <p className="mb-3">
            This Service Agreement is a monthly agreement, automatically
            renewable unless either party requests change or termination. Either
            party may terminate this Service Agreement by notifying the other
            party 30 days in advance of the termination date. GoLeads may also
            terminate this Service Agreement or discontinue the Service
            immediately, without prior notice or liability for any or no reason.
            If you have purchased the Services, you will pay in full for the
            Service up to and including the last day of the twelfth (12th) month
            from origination of the service on which the Service is provided.
          </p>

          <p className="mb-3">
            To cancel the Service, you must contact GoLeads via email, fax,
            postal mail or phone. GoLeads will keep the service in effect for 12
            consecutive months, non-cancellable. If the service is terminated
            before the end of twelve (12) months, GoLeads reserves the right to
            charge the balance of the twelve (12) month service to the
            individual. GoLeads may, but is not obligated to, delete archived
            data, but will not do so until 30 days after the termination of this
            Agreement.
          </p>

          <p className="mb-3">
            Upon expiration or termination, you will immediately cease all use
            of the software and any documentation. Except for the License
            granted in Section 2 and except as otherwise expressly provided
            herein, all sections of this Service Agreement which by their nature
            should survive termination will survive termination, including,
            without limitation, accrued rights to payment, warranty disclaimers,
            and limitations of liability. Termination is not an exclusive remedy
            and all other remedies will be available whether or not the license
            is terminated. Notwithstanding the foregoing, if you are
            dissatisfied with the Service, the materials available on or through
            the Service, or with any of GoLeads terms and conditions, your sole
            and exclusive remedy is to discontinue using the Service.
          </p>

          <p className="mb-3">
            <strong>8. Warranty and Disclaimer</strong>
          </p>

          <p className="mb-3">
            THE SERVICE IS PROVIDED "AS IS" WITHOUT WARRANTY OF ANY KIND, AND
            GOLEADS DISCLAIMS ALL WARRANTIES, EITHER EXPRESS OR IMPLIED,
            INCLUDING, BUT NOT LIMITED TO, IMPLIED WARRANTIES OF
            MERCHANTABILITY, MERCHANTABLE QUALITY,CORRESPONDENCE TO DESCRIPTION,
            FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. SOME STATES DO
            NOT ALLOW LIMITATIONS ON HOW LONG AN IMPLIED WARRANTY LASTS, SO THE
            ABOVE LIMITATION MAY NOT APPLY TO YOU. IF PERMITTED BY LAW, GOLEADS
            LIABILITY IS LIMITED TO RESUPPLYING THE SERVICE. GOLEADS DOES NOT
            REPRESENT OR WARRANT THAT THE SERVICE WILL BE UNINTERRUPTED OR
            ERROR-FREE, THAT DEFECTS WILL BE CORRECTED, OR THAT THIS SITE OR THE
            SERVER THAT MAKES IT AVAILABLE, ARE FREE OF VIRUSES OR OTHER HARMFUL
            COMPONENTS. ANY MATERIAL DOWNLOADED OR OTHERWISE OBTAINED THROUGH
            THE USE OF THE SERVICE IS DONE AT YOUR OWN DISCRETION AND RISK AND
            THAT YOU WILL BE SOLELY RESPONSIBLE FOR ANY DAMAGE TO YOUR COMPUTER
            SYSTEM OR LOSS OF DATA THAT RESULTS FROM THE DOWNLOAD OF ANY SUCH
            MATERIAL.
          </p>

          <p className="mb-3">
            <strong>9. Limitation of Liability</strong>
          </p>

          <p className="mb-3">
            GOLEADS TOTAL LIABILITY, IF ANY, WITH RESPECT TO THE SUBJECT MATTER
            OF THIS SERVICE AGREEMENT (INCLUDING, BUT NOT LIMITED TO, LIABILITY
            ARISING OUT OF CONTRACT, TORT, STRICT LIABILITY, BREACH OF WARRANTY
            OR OTHERWISE), WILL BE LIMITED TO THE FEES PAID BY YOU TO GOLEADS
            FOR THE SERVICE UNDER THIS SERVICE AGREEMENT IN THE 12 MONTHS PRIOR
            TO THE ACT OF INJURY THAT GAVE RISE TO THE LIABILITY. GOLEADS AND
            ITS LICENSORS WILL NOT BE LIABLE IN ANY EVENT FOR LOSS OR INACCURACY
            OF DATA, LOSS OF PROFITS OR REVENUE, OR INDIRECT, SPECIAL,
            INCIDENTAL OR CONSEQUENTIAL DAMAGES (INCLUDING, WITHOUT LIMITATION,
            THE COST OF ANY SUBSTITUTE PROCUREMENT), WHETHER OR NOT FORESEEABLE
            AND EVEN IF GOLEADS HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH
            DAMAGES.
          </p>

          <p className="mb-3">
            <strong>10. U.S. Government Matters</strong>
          </p>

          <p className="mb-3">
            You may not remove or export from the United States or allow the
            export or re-export of any part of the software or applicable
            documentation, if any, or any direct product thereof in violation of
            any restrictions, laws or regulations of the United States
            Department of Commerce, the United States Department of Treasury
            Office of Foreign Assets Control, or any other United States or
            foreign agency or authority. As defined in FAR section 2.101, the
            Software and Documentation licensed in this Service Agreement are
            "commercial items" and according to DFAR section 252.227-7014(a)(1)
            and (5) are deemed to be "commercial computer software" and
            "commercial computer software documentation." Consistent with DFAR
            section 227.7202 and FAR section 12.212, any use modification,
            reproduction, release, performance, display, or disclosure of such
            commercial software or commercial software documentation by the U.S.
            Government will be governed solely by the terms of this Service
            Agreement and will be prohibited except to the extent expressly
            permitted by the terms of this Service Agreement.
          </p>

          <p className="mb-3">
            <strong>11. Third Party Linking</strong>
          </p>

          <p className="mb-3">
            GoLeads may, at its election, provide links from the Service to
            other World Wide Web sites or resources. Because GoLeads has no
            control over such sites and resources, you acknowledge and agree
            that GoLeads is not responsible for the availability of such
            external sites or resources, and does not endorse and is not
            responsible or liable for any Content, advertising, products, or
            other materials on or available from such sites or resources. You
            further acknowledge and agree that GoLeads shall not be responsible
            or liable, directly or indirectly, for any damage or loss caused or
            alleged to be caused by or in connection with use of or reliance on
            any such Content, goods or services available on or through any such
            site or resource.
          </p>

          <p className="mb-3">
            <strong>12. Miscellaneous</strong>
          </p>

          <p className="mb-3">
            This Agreement is between GoLeads and you, and is not for the
            benefit of any third party, whether directly or indirectly. The
            failure of either party to exercise in any respect any right
            provided for herein will not be deemed a waiver of any further
            rights hereunder. If any provision of this Service Agreement is
            found to be unenforceable or invalid, that provision will be limited
            or eliminated to the minimum extent necessary so that this Service
            Agreement will otherwise remain in full force and effect and
            enforceable. This Service Agreement is not assignable, transferable
            or sublicensable by you except with GoLeads prior written consent.
            THIS SERVICE AGREEMENT WILL BE GOVERNED BY AND CONSTRUED IN
            ACCORDANCE WITH THE LAWS OF THE STATE OF NEBRASKA WITHOUT REGARD TO
            THE CONFLICT OF LAWS PROVISIONS THEREOF. YOU AND GOLEADS AGREE TO
            SUBMIT TO THE EXCLUSIVE JURISDICTION OF THE COURTS LOCATED IN THE
            COUNTY OF DOUGLAS IN THE STATE OF NEBRASKA. You and GoLeads agree
            that any cause of action arising out of or related to this Service
            must commence within one (1) year after the cause of action arose;
            otherwise, such cause of action is permanently barred. Both parties
            agree that this Service Agreement is the complete and exclusive
            statement of the mutual understanding of the parties and supersedes
            and cancels all previous written and oral agreements, communications
            and other understandings relating to the subject matter of this
            Service Agreement, and that all modifications must be in a writing
            signed by both parties, except as otherwise provided herein. No
            agency, partnership, joint venture, or employment is created as a
            result of this Service Agreement and you do not have any authority
            of any kind to bind GoLeads in any respect whatsoever. In any action
            or proceeding to enforce rights under this Service Agreement, the
            prevailing party will be entitled to recover costs and attorneys'
            fees. All notices under this Service Agreement will be in writing
            and will be deemed to have been duly given when received, if
            personally delivered; when receipt is electronically confirmed, if
            transmitted by facsimile or e-mail; the day after it is sent, if
            sent for next day delivery by recognized overnight delivery service;
            and upon receipt, if sent by certified or registered mail, return
            receipt requested. GoLeads failure to exercise or enforce any right
            or provision of this Agreement shall not constitute a waiver of such
            right or provision unless acknowledged and agreed to by an
            authorized representative of GoLeads in writing. It is the express
            will of the parties that this agreement and all related documents
            have been drawn up in English. C'est la volonte expresse des parties
            que la presente convention ainsi que les documents qui s'y
            rattachent soient rediges en anglais.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsAndCondition;
